// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__jVrLf","content":"RecentSearches_content__3D7ML"};